import { Alert, AlertTitle, Button, Container, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useRef, useState } from "react";
import { FaPlus, } from "react-icons/fa";
import Loadingspinner from "../Components/loading";
import { getsessionuser } from "../Utils/sessions";
import { Addstandingorderurl } from "../Utils/urls";



const Standingorder = ({ onsuccessfund, onfailfund, oncancelfund, wallet }) => {
    const user = getsessionuser()

    //basics
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [loading, setloading] = useState(false);

    const [interval, setinterval] = useState('');
    const [startdate, setstartdate] = useState('');
    const [amount, setamount] = useState('');


    const add = () => {
        setloading(true)
        axios.post(Addstandingorderurl, {
            userid: user?.id,
            startdate: startdate,
            interval: interval,
            amount: parseInt(amount),
        }).then(function (response) {
            setloading(false)
            if (!response.data.error) {
                setsuccess("Success.Standing order added sucessfully")
                setTimeout(() => {
                    setsuccess()
                    onsuccessfund()
                }, 3000);
                //console.log(response.data)
            } else {
                seterror(response.data.message);
            }
            // 
        }).catch(function (error) {
            setloading(false)
            seterror("Sorry there was an error try again later")
            //if(error.response.status === 401 || error.response.status === 400){}

        });
    }



    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 4,
            borderRadius:3
        }} maxWidth="xs">
            {error?.length > 0 &&
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {error} — <strong>check it out!</strong>
                </Alert>}
            {success?.length > 0 &&
                <Alert severity="success">
                    <AlertTitle>Success</AlertTitle>
                    {success}
                </Alert>}
            {loading && <Loadingspinner />}
            <div style={{ padding: 5 }}>
                <Container maxWidth="md" className="containerwithshadow" style={{ marginTop: 30 }}>
                    <Typography sx={{ fontWeight: "bold" }}>
                        Add a standing order
                    </Typography>
                    <div style={{ marginTop: 30, flexWrap: "wrap" }}>
                        <div style={{ marginBottom: 15 }}>
                            <div style={{ fontSize: 15, marginTop: 5 }}>
                                Amount: <text style={{ color: "red", fontSize: 12 }}>Max {wallet}</text>
                            </div>
                            <TextField
                                id="outlined-basic"
                                sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: "80%" }}
                                value={amount}
                                FormHelperTextProps={{ fontSize: 10 }}
                                onChange={(e) => e.target.value < wallet && setamount(e.target.value)}
                                inputProps={{ fontSize: 10 }}
                                placeholder="amount"
                                type={"number"}
                                variant="outlined" size="small" /><br />
                        </div>
                        <div style={{ marginBottom: 15 }}>
                            <div style={{ fontSize: 15, marginTop: 5 }}>
                                Start date:
                            </div>
                            <TextField
                                id="outlined-basic"
                                sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2 }}
                                value={startdate}
                                FormHelperTextProps={{ fontSize: 10 }}
                                onChange={(e) => setstartdate(e.target.value)}
                                inputProps={{ fontSize: 10 }}
                                placeholder="amount"
                                type={"date"}
                                variant="outlined" size="small" /><br />
                        </div>
                        <div style={{ marginBottom: 15 }}>
                            <div style={{ fontSize: 15, marginTop: 5 }}>
                                Interval:
                            </div>
                            <TextField
                                id="outlined-basic"
                                sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: "80%" }}
                                value={interval}
                                FormHelperTextProps={{ fontSize: 10 }}
                                onChange={(e) => setinterval(e.target.value)}
                                inputProps={{ fontSize: 10 }}
                                placeholder="interval in days"
                                type={"number"}
                                variant="outlined" size="small" /><br />
                        </div>
                        <div style={{ marginBottom: 15 }}>
                            <div>
                                <Button disabled={(!startdate || !interval || !amount) && true} onClick={() => add()} variant="contained" sx={{ height: 30, fontSize: 12, marginRight: 2 }}>Submit</Button>
                                <Button onClick={() => oncancelfund()} variant="contained" sx={{ height: 30, fontSize: 12 }}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </Container>
    )
}

export default Standingorder;